export const ASPECT_RATIO = 15 / 11;
